import React from "react";
import { useNavigate } from "react-router-dom";

const ReportCard = ({ title, description, link }) => {
  const navigate = useNavigate();

  return (
    <div className="card shadow-sm h-100 border-0">
      <div className="card-body d-flex flex-column">
        <h5 className="fw-bold">{title}</h5>
        <p className="text-muted flex-grow-1">{description}</p>
        <button
          className="btn btn-outline-primary mt-2"
          onClick={() => navigate(link)}
        >
          Display Report →
        </button>
      </div>
    </div>
  );
};

export default ReportCard;
